import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

import {
  ILinkPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/LinkPropertyTypeStrategy/types/ILinkPropertyTypeInterfaces'
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'

export function useLinkValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Input

  const fullValueToText = (value: ILinkPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance) => {
    return value?.url || ''
  }

  const getTitleText = (value: ILinkPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance): string => {
    if(!value?.url) return ''
    if(value.title) {
      return value.title
    }
    const url = value.url.toLowerCase()
    if(url.includes('meet.google.com')) {
      return 'Google Meet'
    } else if(url.includes('zoom.us')) {
      return 'Zoom'
    } else if(url.includes('teams.microsoft.com')) {
      return 'Microsoft Teams'
    } else if(url.includes('github.com')) {
      return 'GitHub'
    } else if(url.includes('youtube.com') || url.includes('youtu.be')) {
      return 'YouTube'
    } else if(url.includes('twitter.com') || url.includes('x.com')) {
      return 'Twitter'
    } else if(url.includes('linkedin.com')) {
      return 'LinkedIn'
    } else if(url.includes('facebook.com')) {
      return 'Facebook'
    } else if(url.includes('instagram.com')) {
      return 'Instagram'
    } else if(url.includes('hypris.com') || url.includes('hypris')) {
      return 'Hypris'
    } else if(url.includes('reddit.com')) {
      return 'Reddit'
    } else if(url.includes('discord.com') || url.includes('discord.gg')) {
      return 'Discord'
    } else if(url.includes('slack.com')) {
      return 'Slack'
    } else if(url.includes('notion.so') || url.includes('notion.com')) {
      return 'Notion'
    } else if(url.includes('figma.com')) {
      return 'Figma'
    } else if(url.includes('dribbble.com')) {
      return 'Dribbble'
    } else if(url.includes('behance.net')) {
      return 'Behance'
    } else if(url.includes('medium.com')) {
      return 'Medium'
    } else if(url.includes('stackoverflow.com')) {
      return 'Stack Overflow'
    } else if(url.includes('trello.com')) {
      return 'Trello'
    } else if(url.includes('asana.com')) {
      return 'Asana'
    } else if(url.includes('jira.') || url.includes('atlassian.com')) {
      return 'Jira'
    } else if(url.includes('dropbox.com')) {
      return 'Dropbox'
    } else if(url.includes('drive.google.com')) {
      return 'Google Drive'
    } else if(url.includes('onedrive.live.com') || url.includes('onedrive.com')) {
      return 'OneDrive'
    } else if(url.includes('spotify.com')) {
      return 'Spotify'
    } else if(url.includes('apple.com')) {
      return 'Apple'
    } else if(url.includes('microsoft.com')) {
      return 'Microsoft'
    } else if(url.includes('amazon.com') || url.includes('amazon.')) {
      return 'Amazon'
    } else if(url.includes('netflix.com')) {
      return 'Netflix'
    } else if(url.includes('twitch.tv')) {
      return 'Twitch'
    }
    try {
      const urlObj = new URL(value.url)
      return urlObj.hostname.replace('www.', '')
    } catch {
      return value.url
    }
  }

  const getHrefFromValue = (value: ILinkPropertyTypeInterfaces['fullValue']) => {
    return value?.url || ''
  }

  const fullValueToInputValue = (value: ILinkPropertyTypeInterfaces['fullValue']) => {
    if(!value) {
      return null
    }
    return {
      url: value.url || '',
    }
  }

  const searchToFilterQuery = (search: string, databaseProperties: IDatabasePropertyResponseInstance[]): IFilter => {
    const filterItems = []
    const subProperties = ['url']
    for(const databaseProperty of databaseProperties) {
      for(const subProperty of subProperties) {
        filterItems.push({
          type: FilterItemType.Property,
          id: databaseProperty.id,
          subProperty,
          operator: {
            type: FilterPropertyOperator.Contains,
          },
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: search,
          },
          isDisabled: false,
        })
      }
    }
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: filterItems.flat(),
    }
  }

  const compareItemValues = (
    valueA: ILinkPropertyTypeInterfaces['fullValue'],
    valueB: ILinkPropertyTypeInterfaces['fullValue'],
    sortDirection: '1' | '-1',
  ): number => {
    const hasValueA = valueA && valueA.url
    const hasValueB = valueB && valueB.url
    
    if (!hasValueA && !hasValueB) return 0
    if (!hasValueA) return 1
    if (!hasValueB) return -1
    
    const urlA = String(valueA.url || '')
    const urlB = String(valueB.url || '')
    const comparison = urlA.localeCompare(urlB)
    
    return sortDirection === '1' ? comparison : -comparison
  }

  return $$({
    fullValueToText,
    getTitleText,
    getHrefFromValue,
    fullValueToInputValue,
    strategyComponentType,
    searchToFilterQuery,
    compareItemValues,
  })
}
